import React, { ReactElement } from "react";

export default function AuthError(): ReactElement {
  return <div>Auth Error</div>;
}
